<div class="search-container">
  <!-- Introducción -->
  <div class="search-intro">
    <div class="intro-content">
      <img src="/assets/imagotipo.png" alt="BarBook" class="intro-logo" (click)="goHome()" />
      <div class="intro-text">
        <h1 class="intro-title">Busca bares y listas</h1>
        <p class="intro-subtitle">Explora bares, horarios y listas compartidas por otros usuarios</p>
      </div>
    </div>
  </div>

  <!-- Header Negro con Buscador -->
  <div class="search-header">
    <div class="search-input-wrapper">
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <input
        #searchInput
        type="text"
        [(ngModel)]="searchQuery"
        (input)="onSearchInput($event)"
        (focus)="onSearchFocus()"
        (keypress)="onSearchKeyPress($event)"
        placeholder="Buscar bares, ubicación..."
        class="search-input"
      />
      <button class="search-button" (click)="performSearch()" [disabled]="isSearching">
        <svg class="search-icon-button" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <span class="button-text" *ngIf="!isSearching">Buscar</span>
        <span class="button-text" *ngIf="isSearching">...</span>
      </button>
    </div>

    <!-- Sugerencias -->
    <div class="suggestions-dropdown" *ngIf="showSuggestions && filteredSuggestions.length > 0">
      <div class="suggestions-header">
        <span>Búsquedas recientes</span>
      </div>
      <div class="suggestions-list">
        <div *ngFor="let suggestion of filteredSuggestions" class="suggestion-item">
          <button class="suggestion-text" (click)="selectSuggestion(suggestion)">
            <svg class="history-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            {{ suggestion }}
          </button>
          <button class="suggestion-delete" (click)="deleteSuggestion(suggestion)" title="Eliminar">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Backdrop historial -->
  <div class="suggestions-backdrop" *ngIf="showSuggestions && filteredSuggestions.length > 0" (click)="showSuggestions = false"></div>

  <!-- Contenido Principal -->
  <div class="search-content">
    <!-- Segmentos (Bares / Listas) -->
    <div class="search-segments" *ngIf="hasSearched">
      <button 
        class="segment-button" 
        [class.active]="searchType === 'bars'"
        (click)="onSegmentChange('bars')"
      >
        Bares
      </button>
      <button 
        class="segment-button" 
        [class.active]="searchType === 'lists'"
        (click)="onSegmentChange('lists')"
      >
        Listas
      </button>
    </div>

    <!-- Descubrimiento (Sin búsqueda) -->
    <div class="discovery-section" *ngIf="showDiscovery">
      <div class="discovery-content">
        <svg class="discovery-icon" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <h2>Descubre los mejores bares</h2>
        <p>Busca bares, ubicaciones o explora listas de otros usuarios</p>
      </div>
    </div>

    <!-- Resultados -->
    <div class="results-section" *ngIf="hasSearched && !isSearching">
      <!-- Bares -->
      <div *ngIf="searchType === 'bars'">
        <div *ngIf="bars.length > 0" class="results-list">
          <app-bar-entry *ngFor="let bar of bars" [bar]="bar" (seeDetail)="onSeeDetail($event)"></app-bar-entry>
        </div>
        <div *ngIf="bars.length === 0" class="empty-state">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
          <p>No se encontraron bares</p>
        </div>
      </div>

      <!-- Listas -->
      <div *ngIf="searchType === 'lists'">
        <div *ngIf="lists.length > 0" class="results-list results-list--lists">
          <app-list-entry *ngFor="let list of lists" [listEntry]="list" (selected)="onListSelected($event)"></app-list-entry>
        </div>
        <div *ngIf="lists.length === 0" class="empty-state">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
          </svg>
          <p>No se encontraron listas</p>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="isSearching" class="loading-state">
      <div class="spinner"></div>
      <p>Buscando...</p>
    </div>
  </div>
</div>
